import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgreementViewModel } from 'libs/core/src/lib/model/view-model/agreement/agreement.view.model';

export interface BasketAgreementComponentInterface {
  agreements: AgreementViewModel[];
  valid();
}

@Component({
  template: ''
})
export class BasketAgreementComponent implements OnInit, BasketAgreementComponentInterface {
  @Input()
  public agreements: AgreementViewModel[] = [];

  @Input()
  public checkAllId = 'checkAllCheckbox';
  public checkAll: AgreementViewModel;

  @Output() change = new EventEmitter<{ checked: boolean; index: number }>();

  constructor() {}

  ngOnInit() {
    this.checkAll = new AgreementViewModel();
    this.checkAll.id = this.checkAllId;
    this.checkCheckAll();
  }

  checkCheckAll(checked = false) {
    if (!checked) {
      this.checkAll.checked = false;
    }

    if (!this.agreements.find((c) => !c.checked)) {
      this.checkAll.checked = true;
    }
  }

  checkAllOnChange() {
    this.agreements = this.agreements.map((c, index) => {
      c.checked = this.checkAll.checked;
      this.onChange(c, index);
      return c;
    });
  }

  public valid() {
    this.agreements = this.agreements.map((c) => {
      c.valid = c.checked || !c.required;
      return c;
    });
  }

  onChange(agreement, index) {
    if (!agreement.valid) {
      agreement.valid = agreement.checked || !agreement.required;
    }

    this.checkCheckAll(agreement.checked);
    this.change.emit({ checked: agreement.checked, index });
  }
}
